import { mfestsApi } from "api/mfests_api";

export const getUserSettings = async ({ authToken, slug }) => {
  const data = await mfestsApi.get({ authToken, url: `user/settings` });
  return data.data[0];
};

export const putUsername = async ({ authToken, username }) => {
  return await mfestsApi.put({ authToken, url: 'user/username', body: { username } });
}